import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: '/', label: '首页', icon: 'ri-home-4-line' },
    { to: '/category/movie', label: '分类浏览', icon: 'ri-grid-line' },
    { to: '/about', label: '关于我们', icon: 'ri-information-line' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className={`ri-flashlight-line text-2xl ${scrolled ? 'text-primary-500' : 'text-background-50'}`}></i>
            </div>
            <span className={`font-heading text-xl font-bold whitespace-nowrap transition-colors ${scrolled ? 'text-foreground-900' : 'text-background-50'}`}>
              黑马磁力
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`flex items-center gap-1.5 text-sm font-medium whitespace-nowrap transition-colors hover:text-primary-500 ${
                  location.pathname === link.to || (link.to !== '/' && location.pathname.startsWith(link.to))
                    ? scrolled ? 'text-primary-500' : 'text-primary-300'
                    : scrolled ? 'text-foreground-700' : 'text-background-50/90'
                }`}
              >
                <i className={`${link.icon} text-base`}></i>
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm transition-colors ${
              scrolled
                ? 'bg-background-100 text-foreground-500'
                : 'bg-background-50/20 text-background-50/80'
            }`}>
              <i className="ri-search-line text-base"></i>
              <input
                type="text"
                placeholder="搜索磁力资源..."
                className={`bg-transparent border-none outline-none text-sm w-40 placeholder-current ${
                  scrolled ? 'text-foreground-800' : 'text-background-50'
                }`}
              />
            </div>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              scrolled ? 'text-foreground-700 hover:bg-background-100' : 'text-background-50 hover:bg-background-50/10'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 animate-in slide-in-from-top-2 duration-200">
          <div className="px-4 py-4 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.to || (link.to !== '/' && location.pathname.startsWith(link.to))
                    ? 'bg-primary-50 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                <i className={`${link.icon} text-lg`}></i>
                {link.label}
              </Link>
            ))}
            <div className="px-4 pt-3">
              <div className="flex items-center gap-2 px-4 py-3 rounded-full bg-background-100 text-foreground-500 text-sm">
                <i className="ri-search-line text-base"></i>
                <input
                  type="text"
                  placeholder="搜索磁力资源..."
                  className="bg-transparent border-none outline-none text-sm w-full text-foreground-800"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}